import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAssignedOrders, updateOrderStatus } from "../../features/orders/orderSlice";
import { useNavigate, Link } from "react-router-dom";
import HeaderT from "./HeaderT";
import FooterB from "./FooterB";

/* ──── Mobile-first Delivery Boy Dashboard ──── */
const S = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
  .dbd-root { font-family:'Inter',sans-serif; background:#f8fafc; min-height:100vh; padding-bottom:90px; }

  /* ── Top section ── */
  .dbd-hero {
    background:linear-gradient(135deg,#0d9488,#14b8a6); padding:28px 20px 36px;
    position:relative; overflow:hidden;
  }
  .dbd-hero::after {
    content:''; position:absolute; bottom:-30px; left:0; right:0;
    height:60px; background:#f8fafc; border-radius:50% 50% 0 0 / 30px;
  }
  .dbd-hero-name { font-size:22px; font-weight:900; color:#fff; margin:0 0 4px; }
  .dbd-hero-sub  { font-size:14px; color:rgba(255,255,255,0.75); }
  .dbd-hero-live { display:inline-flex; align-items:center; gap:6px; margin-top:10px;
    padding:5px 12px; background:rgba(255,255,255,0.15); border-radius:100px;
    font-size:12px; font-weight:700; color:#fff; }
  .dbd-live-dot { width:7px; height:7px; border-radius:50%; background:#fff; animation:dbLive 2s infinite; }
  @keyframes dbLive{ 0%,100%{opacity:1} 50%{opacity:0.3} }

  /* ── KPI ── */
  .dbd-kpi-row { display:flex; gap:12px; padding:0 16px; margin:-22px 0 20px; position:relative; z-index:10; }
  .dbd-kpi {
    flex:1; background:#fff; border-radius:16px; padding:16px 14px;
    box-shadow:0 6px 22px rgba(0,0,0,0.12); display:flex; flex-direction:column; gap:4px;
    border-bottom:3px solid transparent; transition:all 0.25s;
  }
  .dbd-kpi:hover { transform:translateY(-3px); }
  .dbd-kpi-val { font-size:24px; font-weight:900; line-height:1; }
  .dbd-kpi-label { font-size:11px; font-weight:700; color:#94a3b8; text-transform:uppercase; letter-spacing:0.08em; }

  /* ── Orders section ── */
  .dbd-section { padding:0 16px; }
  .dbd-section-head {
    display:flex; align-items:center; justify-content:space-between; margin-bottom:14px;
  }
  .dbd-section-title { font-size:16px; font-weight:800; color:#0f172a; }
  .dbd-count-badge {
    padding:4px 12px; background:#f0fdfa; border:1.5px solid #a7f3d0;
    border-radius:100px; font-size:12px; font-weight:800; color:#0d9488;
  }

  /* ── Order card ── */
  .dbd-order-card {
    background:#fff; border:1.5px solid #e2e8f0; border-radius:18px;
    margin-bottom:14px; overflow:hidden; transition:all 0.25s;
    box-shadow:0 2px 10px rgba(0,0,0,0.05);
  }
  .dbd-order-card:hover { box-shadow:0 8px 26px rgba(0,0,0,0.1); }

  .dbd-order-head {
    padding:14px 18px; display:flex; align-items:center; justify-content:space-between;
    border-bottom:1px solid #f1f5f9;
  }
  .dbd-order-id { font-size:13px; font-weight:800; color:#0f172a; }
  .dbd-order-time { font-size:11px; color:#94a3b8; font-weight:600; }

  .dbd-order-body { padding:14px 18px; }
  .dbd-info-row { display:flex; align-items:center; gap:8px; margin-bottom:8px; last-child:{margin:0} }
  .dbd-info-icon { font-size:15px; flex-shrink:0; width:22px; text-align:center; }
  .dbd-info-text { font-size:13px; color:#475569; font-weight:600; }

  .dbd-order-footer { padding:12px 18px; background:#f8fafc; border-top:1px solid #f1f5f9; display:flex; gap:10px; }

  /* ── Status pill ── */
  .dbd-pill {
    display:inline-flex; align-items:center; gap:4px; padding:4px 12px;
    border-radius:100px; font-size:11px; font-weight:800; text-transform:uppercase; letter-spacing:0.06em;
  }
  .dbd-pill-assigned  { background:#fff7ed; color:#c2410c; border:1px solid #fed7aa; }
  .dbd-pill-active    { background:#eff6ff; color:#1d4ed8; border:1px solid #bfdbfe; }
  .dbd-pill-delivered { background:#f0fdf4; color:#15803d; border:1px solid #bbf7d0; }

  /* ── Action buttons ── */
  .dbd-btn {
    flex:1; padding:10px; border:none; border-radius:12px;
    font-size:13px; font-weight:800; font-family:'Inter',sans-serif;
    cursor:pointer; transition:all 0.2s; letter-spacing:0.04em;
  }
  .dbd-btn-accept { background:#14b8a6; color:#fff; box-shadow:0 4px 14px rgba(20,184,166,0.35); }
  .dbd-btn-accept:hover { background:#0d9488; transform:translateY(-1px); }
  .dbd-btn-deliver { background:#22c55e; color:#fff; box-shadow:0 4px 14px rgba(34,197,94,0.35); }
  .dbd-btn-deliver:hover { background:#16a34a; transform:translateY(-1px); }
  .dbd-btn-outline { background:#f8fafc; color:#475569; border:1.5px solid #e2e8f0; }
  .dbd-btn-outline:hover { background:#f1f5f9; }

  /* ── Delivered section ── */
  .dbd-history-card {
    background:#fff; border:1px solid #e2e8f0; border-radius:14px; padding:14px 16px;
    margin-bottom:10px; display:flex; align-items:center; gap:12px;
    box-shadow:0 1px 6px rgba(0,0,0,0.04);
  }
  .dbd-history-check { width:36px; height:36px; border-radius:10px; background:#f0fdf4;
    display:flex; align-items:center; justify-content:center; font-size:18px; flex-shrink:0; }
  .dbd-history-id { font-size:13px; font-weight:800; color:#0f172a; }
  .dbd-history-loc { font-size:12px; color:#94a3b8; font-weight:600; }

  /* ── Empty state ── */
  .dbd-empty { text-align:center; padding:56px 24px; }
  .dbd-empty-ico { font-size:48px; margin-bottom:12px; }
  .dbd-empty-title { font-size:16px; font-weight:800; color:#0f172a; }
  .dbd-empty-sub { font-size:13px; color:#94a3b8; margin-top:6px; }

  /* ── Loading skeleton ── */
  .dbd-skel { background:linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%);
    background-size:200% 100%; animation:dbSkel 1.4s ease infinite; border-radius:12px; }
  @keyframes dbSkel{0%{background-position:200% 0}100%{background-position:-200% 0}}

  /* ── Tab ── */
  .dbd-tabs { display:flex; gap:0; padding:0 16px; margin-bottom:20px; background:#fff;
    border-bottom:1.5px solid #e2e8f0; }
  .dbd-tab {
    flex:1; padding:13px 0; font-size:13px; font-weight:700; color:#94a3b8;
    background:none; border:none; cursor:pointer; border-bottom:2.5px solid transparent;
    font-family:'Inter',sans-serif; transition:all 0.2s; text-align:center;
  }
  .dbd-tab.active { color:#14b8a6; border-bottom-color:#14b8a6; }
`;

const Ddashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intervalRef = useRef(null);
  const [activeTab, setActiveTab] = useState("active"); // active | delivered
  const [confirmingDelivery, setConfirmingDelivery] = useState(null);

  const { user } = useSelector((s) => s.auth);
  const { orders, isLoading } = useSelector((s) => s.orders);
  const deliveryPersonId = user?._id;

  useEffect(() => {
    if (!user) { navigate("/"); return; }
    if (deliveryPersonId) {
      dispatch(fetchAssignedOrders(deliveryPersonId));
      intervalRef.current = setInterval(() => {
        dispatch(fetchAssignedOrders(deliveryPersonId));
      }, 15000); // refresh every 15s — delivery boys need real-time
    }
    return () => clearInterval(intervalRef.current);
  }, [dispatch, deliveryPersonId, user, navigate]);

  const pendingOrders    = orders?.filter((o) => o.orderStatus === "assigned") || [];
  const activeOrders     = orders?.filter((o) => o.orderStatus === "active")   || [];
  const deliveredOrders  = orders?.filter((o) => o.orderStatus === "delivered") || [];
  const totalOrders      = orders?.length || 0;

  const handleAccept = async (orderId) => {
    await dispatch(updateOrderStatus({ orderId, status: "active" }));
    dispatch(fetchAssignedOrders(deliveryPersonId));
  };

  const handleDeliver = async (orderId) => {
    if (confirmingDelivery === orderId) {
      await dispatch(updateOrderStatus({ orderId, status: "delivered" }));
      dispatch(fetchAssignedOrders(deliveryPersonId));
      setConfirmingDelivery(null);
    } else {
      setConfirmingDelivery(orderId);
    }
  };

  const allActive = [...pendingOrders, ...activeOrders];
  const shownOrders = activeTab === "active" ? allActive : deliveredOrders;

  const statusPill = (status) => {
    const map = {
      assigned:  { cls: "dbd-pill-assigned",  label: "⏳ Pending" },
      active:    { cls: "dbd-pill-active",    label: "🚛 On Route" },
      delivered: { cls: "dbd-pill-delivered", label: "✅ Delivered" },
    };
    const s = map[status] || { cls: "dbd-pill-assigned", label: status };
    return <span className={`dbd-pill ${s.cls}`}>{s.label}</span>;
  };

  return (
    <>
      <style>{S}</style>
      <div className="dbd-root">
        <HeaderT />

        {/* ── Hero ── */}
        <div className="dbd-hero">
          <h1 className="dbd-hero-name">Delivery Dashboard 🚚</h1>
          <p className="dbd-hero-sub">Welcome back, {user?.firstname || "Driver"}</p>
          <div className="dbd-hero-live">
            <div className="dbd-live-dot" />
            Auto-refreshing every 15s
          </div>
        </div>

        {/* ── KPI Row ── */}
        <div className="dbd-kpi-row">
          {[
            { val: totalOrders,             label: "Total",     color: "#14b8a6", border: "#14b8a6" },
            { val: allActive.length,        label: "Active",    color: "#f59e0b", border: "#f59e0b" },
            { val: deliveredOrders.length,  label: "Done",      color: "#22c55e", border: "#22c55e" },
          ].map((k) => (
            <div className="dbd-kpi" key={k.label} style={{ borderBottomColor: k.border }}>
              <div className="dbd-kpi-val" style={{ color: k.color }}>{k.val}</div>
              <div className="dbd-kpi-label">{k.label}</div>
            </div>
          ))}
        </div>

        {/* ── Tabs ── */}
        <div className="dbd-tabs">
          <button className={`dbd-tab${activeTab === "active" ? " active" : ""}`} onClick={() => setActiveTab("active")}>
            🚛 Active ({allActive.length})
          </button>
          <button className={`dbd-tab${activeTab === "delivered" ? " active" : ""}`} onClick={() => setActiveTab("delivered")}>
            ✅ Delivered ({deliveredOrders.length})
          </button>
        </div>

        {/* ── Orders List ── */}
        <div className="dbd-section">
          {isLoading ? (
            [1,2,3].map((i) => (
              <div key={i} style={{ marginBottom: 14 }}>
                <div className="dbd-skel" style={{ height: 140 }} />
              </div>
            ))
          ) : shownOrders.length === 0 ? (
            <div className="dbd-empty">
              <div className="dbd-empty-ico">{activeTab === "active" ? "📋" : "🎉"}</div>
              <div className="dbd-empty-title">
                {activeTab === "active" ? "No active orders" : "No deliveries yet"}
              </div>
              <div className="dbd-empty-sub">
                {activeTab === "active" ? "New orders will appear here automatically" : "Completed orders will show here"}
              </div>
            </div>
          ) : activeTab === "active" ? (
            shownOrders.map((order) => (
              <div className="dbd-order-card" key={order._id}>
                <div className="dbd-order-head">
                  <div>
                    <div className="dbd-order-id">Order #{order._id.slice(-6).toUpperCase()}</div>
                    <div className="dbd-order-time">
                      {new Date(order.createdAt).toLocaleString()}
                    </div>
                  </div>
                  {statusPill(order.orderStatus)}
                </div>

                <div className="dbd-order-body">
                  <div className="dbd-info-row">
                    <span className="dbd-info-icon">👤</span>
                    <span className="dbd-info-text">{order.first_name} {order.last_name}</span>
                  </div>
                  <div className="dbd-info-row">
                    <span className="dbd-info-icon">📞</span>
                    <a className="dbd-info-text" href={`tel:${order.phone_number}`} style={{ color: "#14b8a6" }}>{order.phone_number}</a>
                  </div>
                  <div className="dbd-info-row">
                    <span className="dbd-info-icon">📍</span>
                    <span className="dbd-info-text">{order.address}, {order.city}</span>
                  </div>
                  {order.orderItems?.length > 0 && (
                    <div className="dbd-info-row">
                      <span className="dbd-info-icon">📦</span>
                      <span className="dbd-info-text">{order.orderItems.length} item{order.orderItems.length > 1 ? "s" : ""}</span>
                    </div>
                  )}
                </div>

                <div className="dbd-order-footer">
                  {order.orderStatus === "assigned" && (
                    <button className="dbd-btn dbd-btn-accept" onClick={() => handleAccept(order._id)}>
                      🚛 Accept Order
                    </button>
                  )}
                  {order.orderStatus === "active" && (
                    <button
                      className="dbd-btn dbd-btn-deliver"
                      onClick={() => handleDeliver(order._id)}
                    >
                      {confirmingDelivery === order._id ? "✅ Tap again to confirm!" : "✅ Mark Delivered"}
                    </button>
                  )}
                  <a
                    href={`https://maps.google.com?q=${encodeURIComponent(order.address + " " + order.city)}`}
                    target="_blank" rel="noreferrer"
                    className="dbd-btn dbd-btn-outline"
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", textDecoration: "none" }}
                  >
                    🗺️ Map
                  </a>
                </div>
              </div>
            ))
          ) : (
            deliveredOrders.map((order) => (
              <div className="dbd-history-card" key={order._id}>
                <div className="dbd-history-check">✅</div>
                <div>
                  <div className="dbd-history-id">Order #{order._id.slice(-6).toUpperCase()}</div>
                  <div className="dbd-history-loc">{order.address}, {order.city}</div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <FooterB assignedOrderCount={allActive.length} />
    </>
  );
};

export default Ddashboard;
